import { createAction } from '@reduxjs/toolkit';
import { ICustomer } from '../../../../dto';
import { ACT_SET, MN_CUSTOMERS, TYPE_ELEMENT } from '../../../../common';

export const setCustomer = createAction<ICustomer>(
  `${MN_CUSTOMERS}/${TYPE_ELEMENT}/${ACT_SET}`,
);
